import React from "react";

function Pagination({ page, pages, onPageChange }) {
  return (
    <div className="pagination">
      <button disabled={page <= 1} onClick={() => onPageChange(page - 1)}>
        → הקודם
      </button>
      <span className="page-info">
        עמוד {page} מתוך {pages}
      </span>
      <button disabled={page >= pages} onClick={() => onPageChange(page + 1)}>
        הבא ←
      </button>
    </div>
  );
}

export default Pagination;
